export default __webpack_public_path__ + "images/gm-cdfdf8bcb862134ab9fe838e0a8c3fbb.svg";